<template>
  <div v-if="distributionChannel" class="flex flex-col h-full overflow-hidden">
    <BaseDetailsPreviewEditHeader
      :is-horizontal-layout="isHorizontalLayout"
      :title="
        modifiedDistributionChannel?.company?.name ? modifiedDistributionChannel.company.name : '-'
      "
      link-name="distribution-channels"
      :mode="mode"
      :is-modified="isModified"
      :is-edit-active="distributionChannel.isFromManager || false"
      @edit-mode="mode = 'edit'"
      @cancel="onCancelEdit"
      @save="onSaveChanges"
      @horizontal-layout="(value: boolean) => (isHorizontalLayout = value)" />

    <AppResizableContainer :layout="isHorizontalLayout ? 'vertical' : 'horizontal'" :minSize="300">
      <template #headerTitle v-if="isHorizontalLayout">
        <nav
          role="section-nav"
          class="flex justify-between px-6 text-sm font-medium text-center text-gray-500 sm:px-0 min-h-9">
          <ul class="flex flex-wrap items-center gap-4 pl-4 -mb-px">
            <li
              v-for="tab in headerTabs"
              :key="tab.name"
              @click="selectedTab = tab.name"
              class="py-1.5 cursor-pointer"
              :class="[
                selectedTab === tab.name ? 'border-b-2 border-theme-500' : '',
                tab.validator &&
                tab.validator.some((item) => {
                  return $vDistChannel[item].required?.$invalid;
                })
                  ? 'text-red-500 !border-red-500'
                  : '',
              ]">
              <p>{{ tab.label }}</p>
            </li>
          </ul>
        </nav>
      </template>
      <template #headerContent>
        <!-- Horizontal Layout -->
        <template v-if="isHorizontalLayout">
          <PerfectScrollbar class="w-full h-full py-4 space-y-2" ref="scrollbarId">
            <component
              :is="currentHeaderComponent"
              v-model="modifiedDistributionChannel"
              :mode="mode"
              :isHorizontalLayout="isHorizontalLayout"
              :key="`${selectedTab}-${distributionChannel?.id}`"
              :company-error-message="
                $vDistChannel.company.required.$invalid
                  ? $vDistChannel.company.required.$message
                  : ''
              "
              :mw-account-group-error-message="
                $vDistChannel.mwAccountGroup.required.$invalid
                  ? $vDistChannel.mwAccountGroup.required.$message
                  : ''
              " />
          </PerfectScrollbar>
        </template>

        <!-- Vertical Layout -->
        <template v-else>
          <PerfectScrollbar class="w-full h-full py-4 space-y-2" ref="scrollbarId">
            <BaseAccordion
              v-for="tab in headerTabs"
              :key="tab.name"
              :name="tab.label"
              :error="
                tab.validator &&
                tab.validator.some((item) => {
                  return $vDistChannel[item].required.$invalid;
                })
              ">
              <component
                :is="tab.component"
                v-model="modifiedDistributionChannel"
                :mode="mode"
                :isHorizontalLayout="isHorizontalLayout"
                :key="`${tab.name}-${distributionChannel?.id}`"
                :company-error-message="
                  $vDistChannel.company.required.$invalid
                    ? $vDistChannel.company.required.$message
                    : ''
                "
                :mw-account-group-error-message="
                  $vDistChannel.mwAccountGroup.required.$invalid
                    ? $vDistChannel.mwAccountGroup.required.$message
                    : ''
                " />
            </BaseAccordion>
          </PerfectScrollbar>
        </template>
      </template>
      <template #detailsTitle v-if="isHorizontalLayout">
        <nav
          role="section-nav"
          class="flex justify-between px-6 text-sm font-medium text-center text-gray-500 sm:px-0 min-h-9">
          <ul class="flex flex-wrap items-center gap-4 pl-4 -mb-px">
            <li
              v-for="tab in footerTabs"
              :key="tab.name"
              @click="selectedTab2 = tab.name"
              class="py-1.5 cursor-pointer"
              :class="[selectedTab2 === tab.name ? 'border-b-2 border-theme-500' : '']">
              <p>{{ tab.label }}</p>
            </li>
          </ul>
        </nav>
      </template>
      <template #detailsContent>
        <!-- Horizontal Layout -->
        <template v-if="isHorizontalLayout">
          <PerfectScrollbar class="w-full h-full py-4 space-y-2">
            <component
              :is="currentFooterComponent"
              v-model="modifiedDistributionChannel"
              :mode="mode"
              :isHorizontalLayout="isHorizontalLayout"
              :key="`${selectedTab2}-${distributionChannel?.id}`"
              :isFromManager="distributionChannel.isFromManager || false"
              :total-records="
                selectedTab2 === 'salesPersonsDC'
                  ? salesPersonsDcTotalRecords
                  : selectedTab2 === 'materialsDC'
                    ? materialsDcTotalRecords
                    : 0
              "
              @refresh-data="
                (filterData: TableFilterData) =>
                  selectedTab2 === 'salesPersonsDC'
                    ? loadSalesPersonsDC(filterData)
                    : loadMaterialsDC(filterData)
              "
              @apply-filters="
                (filterData: TableFilterData) =>
                  selectedTab2 === 'salesPersonsDC'
                    ? onSalesPersonsDCApplyFilters(filterData)
                    : onMaterialsDCApplyFilters(filterData)
              "
              @reset-filters="
                () =>
                  selectedTab2 === 'salesPersonsDC'
                    ? onSalesPersonsDCResetFilters()
                    : onMaterialsDCResetFilters()
              " />
          </PerfectScrollbar>
        </template>

        <!-- Vertical Layout -->
        <template v-else>
          <PerfectScrollbar class="w-full h-full py-4 space-y-2">
            <BaseAccordion v-for="tab in footerTabs" :key="tab.name" :name="tab.label">
              <component
                :is="tab.component"
                v-model="modifiedDistributionChannel"
                :mode="mode"
                :isHorizontalLayout="isHorizontalLayout"
                :key="`${tab.name}-${distributionChannel?.id}`"
                :isFromManager="distributionChannel.isFromManager || false"
                :total-records="
                  tab.name === 'salesPersonsDC'
                    ? salesPersonsDcTotalRecords
                    : tab.name === 'materialsDC'
                      ? materialsDcTotalRecords
                      : 0
                "
                @refresh-data="
                  (filterData: TableFilterData) =>
                    tab.name === 'salesPersonsDC'
                      ? loadSalesPersonsDC(filterData)
                      : loadMaterialsDC(filterData)
                "
                @apply-filters="
                  (filterData: TableFilterData) =>
                    tab.name === 'salesPersonsDC'
                      ? onSalesPersonsDCApplyFilters(filterData)
                      : onMaterialsDCApplyFilters(filterData)
                "
                @reset-filters="
                  () =>
                    tab.name === 'salesPersonsDC'
                      ? onSalesPersonsDCResetFilters()
                      : onMaterialsDCResetFilters()
                " />
            </BaseAccordion>
          </PerfectScrollbar>
        </template>
      </template>
    </AppResizableContainer>

    <BaseDrawerConfirm
      :is-active="confirmModalActive"
      @cancel="
        confirmModalActive = false;
        isBackMode = false;
      "
      @confirm="onDiscardChanges" />
  </div>
</template>

<script setup lang="ts">
import { computed, markRaw, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLookupsStore } from '@/stores/lookups';
import { useToastStore } from '@/stores/toast';

import DistributionChannelCreateEdit from '@/components/documents/DistributionChannelCreateEdit.vue';
import DistributionChannelDetailsTabMaterialsDC from '@/components/documents/DistributionChannelDetailsTabMaterialsDC.vue';
import DistributionChannelDetailsTabSalesPersonsDC from '@/components/documents/DistributionChannelDetailsTabSalesPersonsDC.vue';
import AppResizableContainer from '@/components/common/AppResizableContainer.vue';
import BaseDetailsPreviewEditHeader from '@/components/common/BaseDetailsPreviewEditHeader.vue';
import BaseDrawerConfirm from '@/components/common/BaseDrawerConfirm.vue';
import BaseAccordion from '@/components/common/BaseAccordion.vue';

import { getDistributionChannelById, addOrEditDistributionChannel } from '@/services/api/documents';
import { getSalesPersonsDCWithConditions } from '@/services/api/user';
import { getMaterialsDCWithConditions } from '@/services/api/materials';
import type { DistributionChannel } from '@/types/DistributionChannel';
import type { SalesPersonDC } from '@/types/SalesPersonDC';
import type { MaterialDC } from '@/types/MaterialDC';
import type { TableFilterData } from '@/types/Base';
import { RecordMode } from '@/types/Base';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';

import { deepCopy } from '@/utils/data';
import { storeToRefs } from 'pinia';

const { reloadLookups, getCompaniesLookup, getMwAccountGroupsLookup, getSalesPersonsLookup } =
  useLookupsStore();
const { companies } = storeToRefs(useLookupsStore());
const route = useRoute();
const router = useRouter();
const toastStore = useToastStore();
const { t: $t } = useI18n();

const selectedTab = ref('properties');
const selectedTab2 = ref('materialsDC');
const isHorizontalLayout = ref(true);

type TabItem = {
  name: string;
  label: string;
  component: any;
  validator?: string[];
};

const headerTabs = ref<TabItem[]>([
  {
    name: 'properties',
    label: $t('document-type.properties'),
    component: markRaw(DistributionChannelCreateEdit),
    validator: ['company', 'mwAccountGroup'],
  },
]);

const footerTabs = ref<TabItem[]>([
  {
    name: 'materialsDC',
    label: $t('material.materials'),
    component: markRaw(DistributionChannelDetailsTabMaterialsDC),
  },
  {
    name: 'salesPersonsDC',
    label: $t('pages.salespersons-management'),
    component: markRaw(DistributionChannelDetailsTabSalesPersonsDC),
  },
]);

const currentHeaderComponent = computed(() => {
  const selected = headerTabs.value.find((tab) => tab.name === selectedTab.value);
  return selected ? selected.component : null;
});

const currentFooterComponent = computed(() => {
  const selected = footerTabs.value.find((tab) => tab.name === selectedTab2.value);
  return selected ? selected.component : null;
});

const distributionChannel = ref<DistributionChannel>();
const modifiedDistributionChannel = ref<DistributionChannel>();
const isModified = ref<boolean>(false);
const mode = ref<'view' | 'edit'>('view');
const confirmModalActive = ref(false);
const isBackMode = ref(false);

const salesPersonsDCList = ref<SalesPersonDC[]>([]);
const salesPersonsDcTotalRecords = ref(0);
const materialsDCList = ref<MaterialDC[]>([]);
const materialsDcTotalRecords = ref(0);

watch(
  () => modifiedDistributionChannel.value,
  (newData) => {
    isModified.value = JSON.stringify(newData) !== JSON.stringify(distributionChannel.value);

    validationDistributionChannelModel.value.company = newData?.companyID || '';
    validationDistributionChannelModel.value.mwAccountGroup = newData?.mwAccountGroupID || '';

    $vDistChannel.value.$touch();
  },
  { deep: true }
);

onMounted(async () => {
  await getCompaniesLookup();
  await getMwAccountGroupsLookup();
  await getSalesPersonsLookup();
  await loadData();
});

async function loadData() {
  const response = await getDistributionChannelById(route.params.id as string);

  if (response) {
    distributionChannel.value = response;
    if (!distributionChannel.value.salesPersonsDC) {
      distributionChannel.value.salesPersonsDC = [];
    }
    await loadSalesPersonsDC();
    await loadMaterialsDC();
    distributionChannel.value.salesPersonsDC = salesPersonsDCList.value;
    distributionChannel.value.materialsDC = materialsDCList.value;
    mode.value = 'view';
  } else {
    distributionChannel.value = {
      id: route.params.id as string,
      isFromManager: true,
      isActive: true,
      companyID: companies.value[0]?.id || '',
      company: companies.value[0] || { id: '', name: '' },
      mwAccountGroupID: '',
      mwAccountGroup: { id: '', accountGroup: '', mwEntity: '' },
      exvan: false,
      orders: false,
      logistics: false,
      uniqueTradersPerRoute: false,
      isDefault: false,
      materialsDC: [],
      salesPersonsDC: [],
    };
    mode.value = 'edit';
  }
  if (distributionChannel.value) {
    modifiedDistributionChannel.value = deepCopy<DistributionChannel>(distributionChannel.value);
  }
}

async function loadSalesPersonsDC(filterData?: TableFilterData) {
  if (!distributionChannel.value?.id) return;

  // Preserve local unsaved items before loading filtered data
  const localUnsavedItems =
    modifiedDistributionChannel.value?.salesPersonsDC?.filter(
      (item) =>
        item.recordMode === RecordMode.Added ||
        item.recordMode === RecordMode.Modified ||
        item.recordMode === RecordMode.Deleted
    ) || [];

  const response = await getSalesPersonsDCWithConditions({
    ...filterData,
    distributionChannelId: distributionChannel.value.id,
  });

  if (response) {
    let mergedData = [...response.data];

    localUnsavedItems.forEach((localItem) => {
      const existingIndex = mergedData.findIndex((item) => item.id === localItem.id);

      if (existingIndex !== -1) {
        mergedData[existingIndex] = localItem;
      } else {
        mergedData.push(localItem);
      }
    });

    salesPersonsDCList.value = mergedData;
    salesPersonsDcTotalRecords.value = response.count;
    if (modifiedDistributionChannel.value) {
      modifiedDistributionChannel.value.salesPersonsDC = mergedData;
    }
  }
}

async function loadMaterialsDC(filterData?: TableFilterData) {
  if (!distributionChannel.value?.id) return;

  // Preserve local unsaved items before loading filtered data
  const localUnsavedItems =
    modifiedDistributionChannel.value?.materialsDC?.filter(
      (item) =>
        item.recordMode === RecordMode.Added ||
        item.recordMode === RecordMode.Modified ||
        item.recordMode === RecordMode.Deleted
    ) || [];

  const response = await getMaterialsDCWithConditions({
    ...filterData,
    distributionChannelId: distributionChannel.value.id,
  });

  if (response) {
    let mergedData = [...response.data];

    localUnsavedItems.forEach((localItem) => {
      const existingIndex = mergedData.findIndex((item) => item.id === localItem.id);

      if (existingIndex !== -1) {
        mergedData[existingIndex] = localItem;
      } else {
        mergedData.push(localItem);
      }
    });

    materialsDCList.value = mergedData;
    materialsDcTotalRecords.value = response.count;
    if (modifiedDistributionChannel.value) {
      modifiedDistributionChannel.value.materialsDC = mergedData;
    }
  }
}

function onSalesPersonsDCApplyFilters(filterData: TableFilterData) {
  loadSalesPersonsDC(filterData);
}

function onSalesPersonsDCResetFilters() {
  loadSalesPersonsDC();
}

function onMaterialsDCApplyFilters(filterData: TableFilterData) {
  loadMaterialsDC(filterData);
}

function onMaterialsDCResetFilters() {
  loadMaterialsDC();
}

function onCancelEdit(backMode: string) {
  if (isModified.value) {
    confirmModalActive.value = true;
    if (backMode == 'back') {
      isBackMode.value = true;
    }
    return;
  } else if (!distributionChannel.value?.createdDate) {
    router.push('/distribution-channels');
  }
  mode.value = 'view';
}

async function onDiscardChanges() {
  mode.value = 'view';
  confirmModalActive.value = false;
  if (distributionChannel.value) {
    modifiedDistributionChannel.value = deepCopy<DistributionChannel>(distributionChannel.value);
  }

  if (!distributionChannel.value?.createdDate || isBackMode.value) {
    router.push('/distribution-channels');
  }
}

async function onSaveChanges() {
  $vDistChannel.value.$touch();
  if ($vDistChannel.value.$invalid) return;

  mode.value = 'view';

  if (modifiedDistributionChannel.value) {
    const res = await addOrEditDistributionChannel(modifiedDistributionChannel.value);
    if (!res) {
      toastStore.error({ text: 'Failed to save distribution channel' });
      return;
    }
  }

  toastStore.success({ text: 'Successfully saved' });
  await reloadLookups(['distributionChannels']);
  await loadData();
}

const validationDistributionChannelModel = ref({
  company: modifiedDistributionChannel.value?.companyID || '',
  mwAccountGroup: modifiedDistributionChannel.value?.mwAccountGroupID || '',
});

const rulesDistChannel = computed(() => ({
  company: { required: helpers.withMessage($t('messages.errors.requiredField'), required) },
  mwAccountGroup: { required: helpers.withMessage($t('messages.errors.requiredField'), required) },
}));

const $vDistChannel = useVuelidate(rulesDistChannel, validationDistributionChannelModel, {
  $lazy: true,
});
</script>
